import React, { useState } from 'react';
import { AuthenticationsLayout } from '../../../../layouts/Authentications/AuthenticationsLayout';
import { RegistrationForm } from '../../../../registration/RegistrationForm';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';
import PrimaryButton from '../../../../shared/Buttons/PrimaryButton';
import { PartnerRegistrationForm } from '../../../../registration/PartnerRegistrationForm';
import { Link } from 'react-router-dom';
import { AuthPageTitle } from '../../../../shared/Typography/AuthenticationsPageTitle';

export const Registration: React.FC = () => {
    const { t } = useTranslation();
    const [selectedLayout, setSelectedLayout] = useState(null);

    const setLayout = (state) => {
        setSelectedLayout(state);
    };
    return (
        <>
            <AuthenticationsLayout>
                {selectedLayout == null && (
                    <>
                        <AuthPageTitle>{t('REGISTRATION.TITLE')}</AuthPageTitle>
                        <Typography paragraph>
                            {t('REGISTRATION.DESCRIPTION')}
                        </Typography>

                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                gap: '20px',
                                paddingBottom: '10px',
                            }}
                        >
                            <PrimaryButton
                                onClick={() => setLayout('exist')}
                                sx={{ flex: 1 }}
                            >
                                {t(
                                    'REGISTRATION_FORM_FIELDS.BC_USER_REG_BUTTON'
                                )}
                            </PrimaryButton>
                            <PrimaryButton
                                onClick={() => setLayout('new')}
                                sx={{ flex: 1 }}
                            >
                                {t(
                                    'REGISTRATION_FORM_FIELDS.NEW_USER_REG_BUTTON'
                                )}
                            </PrimaryButton>
                        </Box>

                        <Typography paragraph>
                            {t(
                                'REGISTRATION_FORM_FIELDS.HAVE_ACCOUNT'
                            ).toString()}{' '}
                            <Link to="/login">
                                {' '}
                                {t(
                                    'REGISTRATION_FORM_FIELDS.HAVE_ACCOUNT_LINK'
                                ).toString()}
                            </Link>
                        </Typography>
                    </>
                )}
                {selectedLayout === 'new' && (
                    <RegistrationForm handleStateChange={setLayout} />
                )}
                {selectedLayout === 'exist' && (
                    <PartnerRegistrationForm handleStateChange={setLayout} />
                )}
            </AuthenticationsLayout>
        </>
    );
};
